var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page p-viewpoint-persona"},[_c('div',{staticClass:"page__head"},[_c('page-header',{attrs:{"back-location":_vm.localePath({ name: 'viewpoint' }),"title":"page_persona.title"}})],1),_vm._v(" "),_c('div',{staticClass:"page__main page__main--fill"},[_c('persona-selector')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }